import React, { createContext, useContext, useState } from "react";

const EmployeeAuthContext = createContext(null);

export function EmployeeAuthProvider({ children }) {
  const [employee, setEmployee] = useState(() => {
    const raw = localStorage.getItem("samrudhi_employee_info");
    return raw ? JSON.parse(raw) : null;
  });

  const login = (token, employeeInfo) => {
    localStorage.setItem("samrudhi_employee_token", token);
    localStorage.setItem("samrudhi_employee_info", JSON.stringify(employeeInfo));
    setEmployee(employeeInfo);
  };

  const logout = () => {
    localStorage.removeItem("samrudhi_employee_token");
    localStorage.removeItem("samrudhi_employee_info");
    setEmployee(null);
  };

  return (
    <EmployeeAuthContext.Provider value={{ employee, login, logout }}>
      {children}
    </EmployeeAuthContext.Provider>
  );
}

export const useEmployeeAuth = () => useContext(EmployeeAuthContext);
